import { defineMessages } from 'react-intl';

type MessageKeys = 'confirmButton';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		confirmButton: {
			id: 'ai-mate.studio-update-agent-draft.confirm-button',
			defaultMessage: 'Confirm',
			description: 'Text for the confirm button in the studio update agent draft action',
		},
	});

export default message;
